import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import { DefectMessage } from 'components/Defects'

const FaultMessagePage: FC = () => {
  return (
    <UserProtectedRoute>
      <DefectMessage />
    </UserProtectedRoute>
  )
}

export default FaultMessagePage
